import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { ApiVisa } from 'blg-akaun-ts-lib';
import { SessionActions } from '../../modules/session/session-controller/actions';
import { SessionSelectors } from '../../modules/session/session-controller/selectors';
import { SessionStates } from '../../modules/session/session-controller/states';
import { DropDownService } from '../../services/drop-down-service';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SharedUtilitiesHelperFunctions } from '../helper-functions';

@Component({
  selector: 'app-select-multi-item-category-level-drop-down',
  templateUrl: './select-multi-item-category-level-drop-down.component.html',
  styleUrls: ['./select-multi-item-category-level-drop-down.component.css']
})
export class SelectMultiItemCategoryLevelDropDownComponent implements OnInit, OnDestroy {

  @Input() itemCategoryLevel: FormControl;
  @Input() apiVisa: ApiVisa;
  @Input() selectedGuid: string;
  @Input() label = 'Item Category Level';
  @Input() options: any;

  @Output() itemCategoryLevelSelected = new EventEmitter<any>();

  serverSideFiltering = new FormControl();
  filteredOptions$: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  selectedRow: any;
  rowData: any = [];
  key = "ItemCategoryLevel"
  labelName = 'Item Category Level';
  labelListGuid;

  protected _onDestroy = new Subject<void>();

  constructor(private dropDownService: DropDownService,
    private readonly store: Store<SessionStates>
  ) { }

  ngOnInit() {
    this.key = "itemCategoryLevel" + this.getLevel();

    // set initial selection
    this.store.select(SessionSelectors.selectDropDownRowData).subscribe(resolved => {
      this.rowData = resolved ? (resolved[this.key] ? resolved[this.key] : []) : [];
      this.store.select(SessionSelectors.selectMasterSettings).subscribe({
        next: (resolve: any) => {
          this.labelListGuid = resolve['ITEM_CATEGORY_GROUP_' + this.getLevel()];
          this.getLabelListRowData(this.labelListGuid);
          if (this.rowData.length === 0) {
            this.getRowData(this.labelListGuid);
          } else {
            this.filteredOptions$.next(this.rowData.slice());
          }
        }
      });
    });
    // listen for search field value changes
    this.serverSideFiltering.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filtering();
      });
  }

  ngOnChanges() {
    //console.log('ngOnChanges');
  }

  getRowData(labelListGuid, keyword?) {
    if (!labelListGuid) return;

    let formData = {
      "limit" : null,
      "orderBy" : "code",
      "order" : "ASC",
      "keyword" : ( keyword ? keyword : ''),
      "filters" : {
        "label_list_guid" : labelListGuid
      }
    }
    this.dropDownService.get("label", formData, this.apiVisa).subscribe(resolved => {
      console.log('dropDownService',resolved)
      this.rowData = [...this.rowData, ...resolved.data];
      this.rowData = SharedUtilitiesHelperFunctions.removeDuplicate(this.rowData, 'guid');

      // sorting
      const sorted = this.rowData.sort((a, b) => (a.code < b.code ? -1 : 1));

      this.store.dispatch(SessionActions.selectDropDownRowData({key: this.key, rowData: this.rowData}));

      //fill the drop down
      if (keyword) {
        this.filteredOptions$.next(resolved.data.slice());
      }
      else {
        this.filteredOptions$.next(this.rowData.slice());
      }
    });
  }

  filtering() {
    if (!this.rowData) {
      return;
    }

    // get the search keyword
    let search = this.serverSideFiltering.value;
    if (!search || search.length < 3) {
      this.filteredOptions$.next(this.rowData.slice());
      return;
    } else {
      search = search.toLowerCase();
      this.getRowData(this.labelListGuid, search);
    }
  }

  onSelect(guid: string) {
    if (guid) {
      this.itemCategoryLevel.patchValue(guid);
      this.selectedRow = this.rowData.find(row => row.guid === guid);
      this.itemCategoryLevelSelected.emit(this.selectedRow);
    }
  }

  isRequired() {
    let value = this.options['required'];
    if (value === true || value === false) {
      return value;
    }
    else if (value) {
      return value.includes(true);
    }
    return false;
  }

  isMultiple() {
    let value = this.options['multiple'];
    if (value === true || value === false) {
      return value;
    }
    else if (value) {
      return value.includes(true);
    }
    return false;
  }

  getLevel() {
    let value = this.options['level'];
    // console.log('level', value);
    if (value) {
      return value;
    }
    return "";
  }

  getLabelListRowData(labelListGuid) {
    let formData = {
      "limit" : null,
      "orderBy" : "code",
      "order" : "ASC",
      "filters" : {
        "guid": labelListGuid,
      }
    }
    this.dropDownService.get("label-list", formData, this.apiVisa).subscribe(resolved => {
      if (resolved.data && resolved.data.length > 0) {
        this.labelName = resolved.data[0]['name'];
      }
    });
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

}
